import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import Event from 'base/event'
import Hub from 'base/hub'

import { Cart } from '@everlane/icon'

const MAX_CART_COUNT = 10

const CartBadge = ({ numberOfLineItems, openCart, topLevelClass }) => {
  const itemCount = numberOfLineItems
  const hideItemCount = numberOfLineItems === 0
  const cartIconCountClassName = classNames({
    'cart-icon__count': !hideItemCount,
    'cart-icon__count--large': itemCount > MAX_CART_COUNT,
  })

  return (
    <div
      className={topLevelClass}
      onClick={() => {
        Hub.pub(Event.Navigation.CART_DROP_DOWN_CLICK)
        openCart()
      }}
    >
      {itemCount > 0 && !hideItemCount && (
        <div className={cartIconCountClassName}>
          {itemCount > MAX_CART_COUNT ? `${MAX_CART_COUNT}+` : itemCount}
        </div>
      )}
      <Cart width="16px" height="16px" strokeWidth={2.5} />
    </div>
  )
}

CartBadge.propTypes = {
  isSyncing: PropTypes.bool,
  isDisabled: PropTypes.bool,
  numberOfLineItems: PropTypes.number,
  openCart: PropTypes.func,
  style: PropTypes.object,
}

export default CartBadge
